/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';
import { NotificationFields } from './fragments';

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  query GetUnreadNotificationsCount {
    getUnreadNotificationsCount
  }
`;

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($input: GetNotificationsInput!) {
    getNotifications(input: $input) {
      data {
        ...NotificationFields
      }
      nextToken
    }
  }
  ${NotificationFields}
`;

export const GET_READ_NOTIFICATIONS = gql`
  query GetReadNotifications($input: GetReadNotificationsInput!) {
    getReadNotifications(input: $input) {
      data {
        ...NotificationFields
      }
      nextToken
    }
  }
  ${NotificationFields}
`;

export const GET_UNREAD_NOTIFICATIONS = gql`
  query GetUnreadNotifications($input: GetUnreadNotificationsInput!) {
    getUnreadNotifications(input: $input) {
      data {
        ...NotificationFields
      }
      nextToken
    }
  }
  ${NotificationFields}
`;
